import React from "react";
import { useTranslation } from "react-i18next";
import "dayjs/locale/en";
import "dayjs/locale/fr";
import "dayjs/locale/es";
import { TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";

const InputDate = (props) => {
  const { i18n } = useTranslation();

const language = ["en", "fr", "es"].includes(i18n.language)
  ? i18n.language
  : "en";

  const {
    label,
    variant,
    size,
    name,
    value,
    openTo = "year",
    views = ["year", "month", "day"],
    onChange,
    error,
    ...other
  } = props;

  return (

    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={language}
    >
      <MobileDatePicker
        openTo={openTo}
        label={label}
        value={value}
        name={name}
        views={views}
        onChange={onChange}
        renderInput={(para) => (
          <TextField
            {...para}
            variant={variant || "filled"}
            size={size || "medium"}
            error={false}
            {...(error && { error: true, helperText: error })}
            {...other}
          />
        )}
      />
    </LocalizationProvider>
  );
};

export default InputDate;
